<body class="ltr main-body leftmenu">

    <!-- Main Content-->
    <div class="main-content side-content pt-0 ml-0">
        <div class="main-container container-fluid scrol">
            <div class="inner-body">
                <div class="row row-sm">
                    <div class="col-lg-12">
                        <div class="card custom-card">
                            <div class="card-body">
                                <div class="row row-sm add-form">
                                    <form autocomplete="off" class="p-0" novalidate [formGroup]="ExamTimeTable">
                                        <div class="col-lg-12 col-md-12" #contentToConvert>
                                            <div class="row clearfix">
                                            

                                                <div class="col-sm-12" *ngIf="istableShow">
                                                    <div class="receipt mt-2">
                                                        <div class="row ">
                                                            <div class="col-sm-3">
                                                                <img src="../../assets/images/logo-light.png"
                                                                    class="header-brand-img reciptLogo desktop-logo"
                                                                    alt="logo">
                                                            </div>
                                                            <div class="col-sm-9">
                                                                <h3 class="mra">{{InstuName}}</h3>
                                                                <h6 class="mra11">( A State University of the Govt. of
                                                                    Assam )</h6>
                                                                <h3 class="mra">Practical Time Table</h3>
                                                                <h6 class="addc">Address: 2nd Floor, Gauhati Medical
                                                                    College Building, Narkashur Hilltop, Bhangagarh,
                                                                    Guwahati-781032,Assam</h6>
                                                                <h6 class="addc">Tel:6026177313 |
                                                                    Email:ssuhs_assam@yahoo.in | Web:
                                                                    http://www.ssuhs.in/ GST No. : 18SHLS03712C1DR</h6>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="receipt-details">
                                                                <div class="row">
                                                                    <div class="col-sm-4">
                                                                        <p><strong>College:</strong>
                                                                            {{cutoffDetails?.College}} -
                                                                            {{cutoffDetails?.CgName}}</p>
                                                                    </div>
                                                                    <div class="col-sm-4">
                                                                        <p><strong>Course:</strong>
                                                                            {{cutoffDetails?.Course}} -
                                                                            {{cutoffDetails?.CoName}}</p>
                                                                    </div>
                                                                     <div class="col-sm-4">
                                                                        <p><strong>Exam:</strong>
                                                                            {{cutoffDetails?.EmCode}} -
                                                                            {{cutoffDetails?.EmName}}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="table-responsive table-container mt-2">
                                                            <table class="styled-table" style="width:100%">
                                                                <thead>
                                                                    <tr>
                                                                        <th width="5%" class="f600 text-center">
                                                                            Sr No
                                                                        </th>
                                                                        <th width="40%" class="f600 text-center">
                                                                            Subject
                                                                        </th>
                                                                        <th width="20%" class="f600 text-center">
                                                                            Head
                                                                        </th>
                                                                        <th width="15%" class="f600 text-center">
                                                                            Date
                                                                        </th>
                                                                        <th class="f600 text-center" width="10%">
                                                                            From Time
                                                                        </th>
                                                                        <th class="f600 text-center" width="10%">
                                                                            To Time
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody id="table_data" formArrayName="ExamArray">
                                                                    <tr style="cursor:pointer;"
                                                                        *ngFor="let exm of getExamArrayControls(); let i = index"
                                                                        [formGroupName]="i">
                                                                        <td class="text-center">{{ i + 1 }}</td>
                                                                        <td class="text-center">
                                                                            {{ exm.get('SubName')?.value }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ exm.get('HeadName')?.value }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ exm.get('Date')?.value | date: 'dd/MM/yyyy' }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ exm.get('PtTimeFrom')?.value | date:'hh:mm a':'UTC' }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ exm.get('PtTimeTo')?.value | date:'hh:mm a':'UTC' }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 row" *ngIf="istableShow">
                                                <div class="col-sm-12 prpl">
                                                    <!-- <button type="button" *ngIf="exTimeCreate" [disabled]="BtnDisable"
                                                        class="btn btn-primary btn-icon-text floatright mt-1"
                                                        (click)="save()">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/save.gif"
                                                                style="margin-right: 5px;">
                                                            Save
                                                        </span>
                                                    </button> -->

                                                    <!-- <button type="button" *ngIf="updateBtn" [disabled]="BtnDisable"
                                                        class="btn btn-primary btn-icon-text floatright mt-1"
                                                        (click)="update()">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/save.gif"
                                                                style="margin-right: 5px;">
                                                            Update
                                                        </span>
                                                    </button> -->

                                                    <button type="button"
                                                        class="btn btn-primary btn-icon-text floatright mr-3 mt-1"
                                                        (click)="downloadAsPDF()">
                                                        <span style="display: contents; align-items: center;">
                                                            Download
                                                        </span>
                                                    </button>

                                                    <!-- <button type="button" [mat-dialog-close]="true"
                                                        class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/turn-left.gif"
                                                                style="margin-right: 7px;">
                                                            Back
                                                        </span>
                                                    </button> -->


                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>
